var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRadioButton24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM8.025 11.589l1.358 1.11c.21.173.515.164.715-.021l5.505-5.097a1.27 1.27 0 0 1 1.775 1.817l-6.773 6.972a1.242 1.242 0 0 1-1.745.037l-2.768-2.623a1.464 1.464 0 0 1 1.933-2.195Z",
    fill: "#2EA7E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButton24);
export default __webpack_public_path__ + "static/media/radio_button_24.f410124d.svg";
export { ForwardRef as ReactComponent };